<template>
    <div class="previewArea" :style="{ height:height + 'px' }">
        <div class="imgArea" v-if="imgVisible">
            <el-image :src="fileInfo.url"/>
        </div>

        <div class="txtArea" v-if="txtVisible">
            <div v-html="txtContent"></div>
        </div>

        <!--
        <div class="wordArea" v-if="wordVisible">
            <div ref="wordFile"></div>
        </div>

        <div class="excelArea" v-if="excelVisible">
            <div v-html="excelData"></div>
        </div>
        -->

        <div class="pdfArea" v-if="pdfVisible">
            <pdf
                v-for="currentPage in pdfPages"
                ref="pdf"
                :src="pdfSrc"
                :key="currentPage"
                :page="currentPage">
            </pdf>
        </div>

        <div class="videoArea">
            <video-player v-if="initPlayerCompleted" class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                x5-video-player-type="h5"
                x5-video-player-orientation="landscape"
                :options="playerOptions">
            </video-player>
        </div>
    </div>
</template>

<script>
    //import XLSX from "xlsx";
    import pdf from 'vue-pdf-signature'
    import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory'
    //import axios from "axios";
    //let docx = require('docx-preview');

    export default {
        props: ['fileInfo','height'],
        components: {
            pdf
        },
        data() {
            return {
               imgVisible: false,
               wordVisible: false,
               excelVisible: false,
               txtVisible: false,
               pdfVisible: false,
               pptVisible: false,
               videoVisible: false,
               txtContent: null,
               excelData: [],
               pdfSrc: null,
               pdfPages: null,
               initPlayerCompleted: false,
               playerOptions: {
                   //播放速度
                   playbackRates: [0.5, 1.0, 1.5, 2.0],
                   //如果true,浏览器准备好时开始回放。
                   autoplay: true,
                   // 默认情况下将会消除任何音频。
                   muted: false,
                   // 导致视频一结束就重新开始。
                   loop: false,
                   // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                   preload: 'auto',
                   language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                   aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                   fluid: true,
                   sources: [{
                       //类型
                       type: "video/mp4",
                       //type: "video/x-msvideo",
                       //url地址
                       src: "",
                   }],
                   //你的封面地址
                   poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                   notSupportedMessage: '此视频暂无法播放，请稍后再试',
                   controlBar: {
                       timeDivider: true,
                       durationDisplay: true,
                       remainingTimeDisplay: false,
                       //全屏按钮
                       fullscreenToggle: true
                   }
               },
            };
        },
        mounted(){
            const imgType = ['jpg','jpeg','png','gif'];
            //const wordType = ['doc','docx'];
            //const excelType = ['xls','xlsx'];
            //const pptType = ['ppt','pptx'];
            const officeType = ['doc','docx','xls','xlsx','ppt','pptx'];
            const videoType = ['mp3','mp4'];

            if(imgType.indexOf(this.fileInfo.type) > -1){
                this.imgVisible = true;
            }
            else if(this.fileInfo.type === 'txt'){
                this.txtVisible = true;
                this.previewTxt();
            }
            /*
            else if(wordType.indexOf(this.fileInfo.type) > -1){
                this.wordVisible = true;
                this.previewWord();
            }
            else if(excelType.indexOf(this.fileInfo.type) > -1){
                this.excelVisible = true;
                this.previewExcel();
            }
            else if(pptType.indexOf(this.fileInfo.type) > -1){
                this.pptVisible = true;
            }
            */
            else if(this.fileInfo.type === 'pdf'){
                this.pdfVisible = true;
                this.previewPdf();
            }

            else if(officeType.indexOf(this.fileInfo.type) > -1){
               this.pdfVisible = true;
               this.previewPdf();
            }
            else if(videoType.indexOf(this.fileInfo.type) > -1){
                this.videoVisible = true;
                this.playerOptions.sources[0].src = this.fileInfo.url;
                if(this.initPlayerCompleted == false) this.initPlayerCompleted = true;
            }
        },
        methods: {
            previewTxt(){
                let xhr = new XMLHttpRequest();
                xhr.open("get", this.fileInfo.url, true);
                xhr.responseType = "blob";
                let _this = this;
                xhr.onload = function () {
                    if (this.status == 200) {
                        const reader = new FileReader();
                        if (typeof FileReader === 'undefined') {
                            this.$message({
                                type: 'info',
                                message: '您的浏览器不支持此类型文件读取'
                            });
                            return;
                        }

                        reader.onload = function () {
                            // console.log('reader.result', reader.result);
                            _this.txtContent = _this.formatter(reader.result);//获取的数据data
                        }
                        reader.readAsText(this.response);
                    }
                };
                xhr.send();
            },
            /*
            previewWord(){
                axios({
                    method: 'get',
                    responseType: 'blob', // 设置响应文件格式
                    url: this.fileInfo.url,
                }).then(({data}) => {
                    docx.renderAsync(data, this.$refs.wordFile) // 渲染到页面预览
                });
            },
            previewExcel(){
                axios({
                    method: 'get',
                    responseType: 'arraybuffer', // 设置响应文件格式
                    url: this.fileInfo.url,
                }).then(({data}) => {
                    let workbook = XLSX.read(new Uint8Array(data), {type:"array"}); // 解析数据
                    var worksheet = workbook.Sheets[workbook.SheetNames[0]]; // workbook.SheetNames 下存的是该文件每个工作表名字,这里取出第一个工作表
                    this.excelData = XLSX.utils.sheet_to_html(worksheet); // 渲染
                });
            },
            */
            previewPdf(){
                this.pdfSrc = pdf.createLoadingTask({
                    url: this.fileInfo.url,
                    cMapPacked: true,
                    CMapReaderFactory
                });

                this.pdfSrc.promise.then(pdf => {
                  this.pdfPages = pdf.numPages;
                }).catch(err => {
                  console.error('pdf 加载失败', err);
                })
            },
            formatter(content){
                content = content.replace(/\n/g, '<br/>');
                content = content.replace(new RegExp(' ', 'gm'), '&nbsp;')

                return content;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .previewArea {
        width: 100%;
        border: 2px solid #DCDFE6;
    }

    .imgArea, .txtArea, .wordArea, .excelArea, .pdfArea {
        width: 100%;
        height: 100%;
        overflow: auto;
    }

    /*
    .imgArea {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    */

    .imgArea /deep/.el-scrollbar {
        .is-vertical {
            width: 15px;
        }
    }

    .txtArea {
        padding: 10px;
    }
</style>



// WEBPACK FOOTER //
// simplePreviewer.vue?d6c3ce1c